import {ListSupplierOffersQueryParams} from "@project/sdk/engineering/zod";
import type {z} from "zod";

export const listSupplierOffersSearchSchema = ListSupplierOffersQueryParams.extend({
  page: ListSupplierOffersQueryParams.shape.page.catch(1).default(1),
  perPage: ListSupplierOffersQueryParams.shape.perPage.catch(20).default(20),
  state: ListSupplierOffersQueryParams.shape.state.catch("ACTIVE"),
  sortKey: ListSupplierOffersQueryParams.shape.sortKey.catch("supplierId"),
  sortDir: ListSupplierOffersQueryParams.shape.sortDir.catch("asc").default("asc"),
});
export type ListSupplierOffersSearchInput = z.input<typeof listSupplierOffersSearchSchema>;
export type ListSupplierOffersSearch = z.output<typeof listSupplierOffersSearchSchema>;
